import axios from 'axios';

export function fetchKeywordSuggestions(keyword) {
  return axios.get('/v2/api/search/keyword_suggestions', {
    params: {
      keyword: keyword
    }
  });
}
